import { render, staticRenderFns } from "./h5ConfigTenantList.vue?vue&type=template&id=0b959b1c&scoped=true"
import script from "./h5ConfigTenantList.vue?vue&type=script&lang=js"
export * from "./h5ConfigTenantList.vue?vue&type=script&lang=js"
import style0 from "./h5ConfigTenantList.vue?vue&type=style&index=0&id=0b959b1c&prod&lang=css"
import style1 from "./h5ConfigTenantList.vue?vue&type=style&index=1&id=0b959b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b959b1c",
  null
  
)

export default component.exports